export enum WebhookEvent {
  LeadCreated = "LeadCreated",
}

export interface Webhook {
  id?: number;
  event: WebhookEvent;
  url: string;
  status: boolean;
  isTouched?: true;
}

export interface WebhookSummary {
  status: boolean;
  updated_at: string;
}
